import React from 'react';
import HashElement from './HashElement.jsx';
import HashLevel from './HashLevel.jsx';

export default class HashTree extends HashLevel {
  constructor(props) {
    super(props);
    this.state = {
      children: props.children,
    };
  }

  onElementClick(elementId) {
    this.setState(this.activateOnly(elementId));
  }

  activateChildrenElement(c, elementId) {
    let updated;

    updated = Object.assign(c, {
      active: c.id === elementId,
      children: c.children.map((_c) => {
        return this.activateChildrenElement(_c, elementId);
      }),
    });
    if (updated.active) {
      this.props.onOpen(updated);
    }

    return updated;
  }

  activateOnly(elementId) {
    return this.state.children.map((c) => {
      return this.activateChildrenElement(c, elementId);
    });
  }

  updateState(obj, callback) {
    this.props.onChange(obj.children, callback);
  }

  UNSAFE_componentWillReceiveProps(props) {
    this.setState({ children: props.children });
  }

  inactiveChildren(c) {
    return Object.assign(c, {
      active: false,
      children: c.children.map((_c) => {
        return this.inactiveChildren(_c);
      }),
    });
  }

  inactiveAll() {
    let inactives = this.state.children.map((c) => {
      return this.inactiveChildren(c);
    });

    this.updateState({ children: inactives });
  }

  updateChildren(c, obj) {
    if (c.id === obj.id) {
      c = obj;
    }
    return Object.assign(c, {
      children: c.children.map((_c) => {
        return this.updateChildren(_c, obj);
      }),
    });
  }

  updateByName(obj) {
    let updated = this.state.children.map((c) => {
      return this.updateChildren(c, obj);
    });

    this.updateState({ children: updated });
  }

  render() {
    return (
      <div className='hashTreeComponent'>
        <div
          className={
            this.state.children.length > 0
              ? 'treeLevel withChildren children_' + this.state.children.length
              : 'treeLevel'
          }
        >
          {this.state.children.map((child, index) => {
            return (
              <HashElement
                key={index}
                ref={child.id}
                className={this.childClass(index, this.state.children.length)}
                data={child}
                id={child.id}
                index={index}
                remove={this.remove.bind(this)}
                onChange={this.onElementUpdate.bind(this)}
                onElementClick={this.onElementClick.bind(this)}
                onUnselect={this.props.onClose}
              />
            );
          })}
          <div className='treeLevelItem hide-disabled'>
            <a
              className='ui icon button green'
              onClick={this.addChildren.bind(this)}
            >
              <i className='icon plus'></i>
            </a>
          </div>
        </div>
      </div>
    );
  }
}
